import classes from './mapDrawerLayers.module.css';

const MapDrawerLayersMainHeader = () => {
  return <div className={classes.mainHeader}>Map Layers</div>;
};

export default MapDrawerLayersMainHeader;
